<style lang="scss">
.icon_flod {
  position: absolute;
  background: rgba(0, 0, 0, 0.4);
  bottom: 0px;
  z-index: 999;
  width: 100%;
  height: 28px;
  color: #ddd0d0;
  font-size: 14px;
  text-align: center;
  cursor: pointer;
}
.nav-content {
  width: 100%;
  height: 100%;
  .logo-content {
    margin-top: 20px;
    text-align: center;
    .logo {
      //  min-width:53px;
      max-height: 50px;
      margin-bottom: 18px;
    }
  }
  .el-checkbox {
    color: #636363;
  }
}
</style>
<template>
  <div
    v-if="secondRouters && secondRouters.length"
    class="nav-content"
    style="position: relative"
  >
    <el-scrollbar
      class="page-component__scroll"
      style="height: calc(100% - 40px)"
    >
<!--      <div class="logo-content">-->
<!--        &lt;!&ndash;<img class="logo" src="/image/logo.svg" alt="">&ndash;&gt;-->
<!--        <img class="logo" :src="getRealUrl(logo)" alt="" />-->
<!--      </div>-->
      <el-menu
        mode="vertical"
        :show-timeout="200"
        :default-active="$route.path"
        :unique-opened="true"
        :collapse="isCollapse"
        ref="testUl"
      >
        <sidebar-item :routes="newSecondRouters"></sidebar-item>
      </el-menu>
    </el-scrollbar>
    <div class="icon_flod">
      <i
        @click="showModal = true"
        v-if="isFactorMenu && !isCollapse"
        class="iconfont icon-shezhi"
        ><span class="ml5" style="font-size: 14px">{{ $t("菜单设置") }}</span>
      </i>
      <i
        @click="
          isCollapse = !isCollapse;
          triggerResize();
        "
        v-if="isCollapse"
        class="el-icon-s-unfold ml15 mt5"
      >
        <span class="ml5">{{ $t("展开") }}</span></i
      >
      <i
        @click="
          isCollapse = !isCollapse;
          showModal = false;
          triggerResize();
        "
        v-else
        class="el-icon-s-fold ml15 mt5"
      >
        <span class="ml5">{{ $t("收起") }}</span></i
      >
    </div>
    <div
      v-if="showModal"
      style="
        width: 100%;
        height: 129px;
        background: #ffffff;
        bottom: 30px;
        position: absolute;
      "
    >
      <i
        class="el-icon-close"
        @click="showModal = false"
        style="
          position: absolute;
          right: 0;
          top: 5px;
          font-size: 22px;
          color: #636363;
        "
      ></i>
      <el-checkbox-group class="mt10 m10" v-model="specialCodes">
        <el-checkbox
          class="ml20 mt10"
          :label="item.specialCode"
          v-for="(item, index) in menuList"
          :key="index"
          >{{ item.title }}</el-checkbox
        >
      </el-checkbox-group>
      <div class="mt20" style="width: 100%; text-align: center">
        <el-button
          size="mini"
          type="primary"
          @click="save()"
          style="width: 150px"
          >{{ $t("保存") }}</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SidebarItem from "./SidebarItem";
import { getDomainPrefix, imgBaseUrl, otherMenuList } from "@/utils/common.js";

export default {
  mounted() {},
  data() {
    return {
      isCollapse: false,
      isFactorMenu: false,
      showModal: false,
      specialCodes: [],
      newSecondRouters: [],
      menuList: [
        //$t('重点监控')
        {
          specialCode: "key_monitor",
          name: "factorInfo",
          title: this.$t("重点监控"),
          code: "projectMonitor",
          path: "/platform/projectMonitor",
          children: [],
          icon: "zdjk",
        },
        {
          specialCode: "group_preview",
          name: "factorInfo",
          title: this.$t("分组预览"),
          code: "dataReport",
          path: "/platform/dataReport",
          children: [],
          icon: "fzyl",
        },
      ],
      logo: "",
    };
  },
  watch: {
    pageConfig: {
      handler(newVal) {
        if (newVal) {
          this.logo = newVal.logoTypeLight || "/image/logo.png";
        }
      },
      immediate: true,
    },
    $route() {
      this.initFactor();
    },
    secondRouters() {
      this.initFactor();
    },
  },
  components: { SidebarItem },
  computed: {
    ...mapGetters(["secondRouters", "pageConfig", "projectInfo", "sidebar"]),
  },
  created() {
    this.initFactor();
  },
  methods: {
    triggerResize() {
      this.$emit("changeCollapse", this.isCollapse);
      this.$nextTick(() => {
        var myEvent = new Event("resize");
        window.dispatchEvent(myEvent); //触发resize事件
      });
    },
    initFactor() {
      this.isFactorMenu = this.secondRouters.find(
        (item) => item.name.includes("factorInfo") || item.specialCode
      )
        ? true
        : false;
      if (this.isFactorMenu) {
        let factorsMenu = JSON.parse(
          localStorage.getItem(process.env.VUE_APP_NODE_ENV + "factorsMenu") ||
            "[]"
        );
        // 会存在国际化转换问题，此处重新转换一次
        let allCodes = factorsMenu.map((it) => it.code);
        factorsMenu = otherMenuList.filter((item) =>
          allCodes.includes(item.code)
        );
        this.newSecondRouters = this.secondRouters.concat(factorsMenu);
        this.specialCodes = factorsMenu.map((item) => item.specialCode);
      } else {
        this.newSecondRouters = this.secondRouters;
      }
      // this.$store.commit('SET_SECONDROUTERS',this.newSecondRouters)
    },
    save() {
      let factorsMenu = [];
      this.menuList.forEach((item) => {
        if (this.specialCodes.includes(item.specialCode)) {
          factorsMenu.push(item);
        }
        let idx = this.secondRouters.findIndex(
          (it) => it.specialCode == item.specialCode
        );
        if (idx != -1) {
          this.secondRouters.splice(idx, 1);
        }
      });
      localStorage.setItem(
        process.env.VUE_APP_NODE_ENV + "factorsMenu",
        JSON.stringify(factorsMenu)
      );
      this.newSecondRouters = this.secondRouters.concat(factorsMenu);
      // this.$store.commit('SET_SECONDROUTERS',this.newSecondRouters)
      this.showModal = false;
    },
    getRealUrl(url) {
      let str = "/image/";
      if (url.indexOf(str) == 0) {
        return url;
      } else {
        return imgBaseUrl + url;
      }
    },
  },
};
</script>
